import { render } from "./PlanActivityPropertiesView.vue?vue&type=template&id=aca9ba36"
import script from "./PlanActivityPropertiesView.vue?vue&type=script&lang=js"
export * from "./PlanActivityPropertiesView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akhenry/Code/openmct-clean/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__